import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { showError, showSuccess } from '../utils/toast';

const PgCadastroSenha = () => {
    const { id, token } = useParams();
    const navigate = useNavigate();
    const [cliente, setCliente] = useState(null);
    const [senha, setSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        validarToken();
    }, [id, token]);

    const validarToken = async () => {
        try {
            const response = await fetch(`https://novo.faestal.com.br/cliente/read.php?id=${id}`);
            const data = await response.json();
            
            if (data && data.length > 0 && data[0].contrato_token === token) {
                setCliente(data[0]);
            } else {
                showError('Link inválido ou expirado.');
                setTimeout(() => navigate('/'), 3000);
            }
        } catch (error) {
            console.error('Erro ao validar token:', error);
            showError('Erro ao validar o link.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (senha.length < 4) {
            showError('A senha deve ter no mínimo 4 caracteres.');
            return;
        }

        if (senha !== confirmarSenha) {
            showError('As senhas não coincidem.');
            return;
        }

        setIsSaving(true);
        try {
            const response = await fetch('https://novo.faestal.com.br/cliente/update.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id_cliente: id,
                    senha: senha
                })
            });

            const result = await response.json();

            if (result.status === 'success') {
                showSuccess('Senha cadastrada com sucesso! Redirecionando...');
                setTimeout(() => {
                    navigate(`/termo/${id}/${token}`);
                }, 2000);
            } else {
                showError('Erro ao cadastrar senha: ' + result.message);
            }
        } catch (error) {
            console.error('Erro ao cadastrar senha:', error);
            showError('Erro ao cadastrar senha.');
        } finally {
            setIsSaving(false);
        }
    };

    if (isLoading) {
        return (
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-6 text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Carregando...</span>
                        </div>
                        <p className="mt-3">Validando informações...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!cliente) {
        return null;
    }

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow">
                        <div className="card-header bg-primary text-white">
                            <h4 className="mb-0">Cadastrar Senha</h4>
                        </div>
                        <div className="card-body">
                            <div className="alert alert-info">
                                <strong>Bem-vindo, {cliente.nome}!</strong>
                                <p className="mb-0 mt-2">CPF: {cliente.cpf}</p>
                            </div>

                            <p className="text-muted mb-4">
                                Crie uma senha segura para acessar o Portal do Cliente FAEWorks.
                            </p>

                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="senha" className="form-label">
                                        Nova Senha <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="senha"
                                        value={senha}
                                        onChange={(e) => setSenha(e.target.value)}
                                        required
                                        minLength={4}
                                        placeholder="Mínimo 4 caracteres"
                                    />
                                    <small className="text-muted">Mínimo 4 caracteres</small>
                                </div>

                                <div className="mb-4">
                                    <label htmlFor="confirmarSenha" className="form-label">
                                        Confirmar Senha <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="confirmarSenha"
                                        value={confirmarSenha}
                                        onChange={(e) => setConfirmarSenha(e.target.value)}
                                        required
                                        minLength={4}
                                        placeholder="Digite a senha novamente"
                                    />
                                </div>

                                <div className="d-grid">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-lg"
                                        disabled={isSaving}
                                    >
                                        {isSaving ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Salvando...
                                            </>
                                        ) : (
                                            'Cadastrar Senha'
                                        )}
                                    </button>
                                </div>
                            </form>

                            <div className="alert alert-warning mt-4">
                                <small>
                                    <strong>Dica:</strong> Use uma senha que você consiga lembrar facilmente, mas que não seja óbvia para outras pessoas.
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PgCadastroSenha;
